import { Component, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { first } from "rxjs/operators";
import { Lookup } from "src/app/model/lookup";
import { LprCameraGroupService } from "src/app/services/lpr-camera-group.service";
import { WebConstants } from "src/app/util/web.constants";
import { CitationViewDialogComponent } from "../../citation-management/citation-view-dialog/citation-view-dialog.component";
import { ToastrService } from "ngx-toastr";
import { UserService } from "src/app/services/user.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { EnforcementVehicleService } from "src/app/services/enforcement-vehicle.service";
import { Inject } from "@angular/core";

@Component({
  selector: "app-vehicle-update-dialog",
  templateUrl: "./vehicle-update-dialog.component.html",
  styleUrls: ["./vehicle-update-dialog.component.scss"],
})
export class VehicleUpdateDialogComponent implements OnInit {
  public form: any;
  public cameraGroupList: Lookup[] = [];
  public userList: Lookup[] = [];

  constructor(
    public dialog: MatDialogRef<VehicleUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public lprCameraGroupService: LprCameraGroupService,
    public toastrService: ToastrService,
    public userService: UserService,
    public enforcementVehicleService: EnforcementVehicleService
  ) {}

  ngOnInit(): void {
    this.initlizeVehicleUpdateForm();
    this.getAllGroups();
    this.getAllUsers();
  }

  initlizeVehicleUpdateForm(): void {
    this.form = new FormGroup({
      id: new FormControl("", Validators.required),
      name: new FormControl("", Validators.required),
      make: new FormControl("", Validators.required),
      model: new FormControl("", Validators.required),
      variant: new FormControl("", Validators.required),
      color: new FormControl("", Validators.required),
      lpn: new FormControl("", Validators.required),
      peoId: new FormControl("", Validators.required),
      cameraGroupId: new FormControl("", Validators.required),
    });

    this.form.get("id").setValue(this.data.id);
    this.form.get("name").setValue(this.data.name);
    this.form.get("make").setValue(this.data.make);
    this.form.get("model").setValue(this.data.model);
    this.form.get("variant").setValue(this.data.variant);
    this.form.get("color").setValue(this.data.color);
    this.form.get("lpn").setValue(this.data.lpn);
    this.form.get("peoId").setValue(this.data.peoId.userId);
    this.form.get("cameraGroupId").setValue(this.data.cameraGroupId.id);
  }

  getAllGroups() {
    this.lprCameraGroupService
      .getAllLprCameraGroup()
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.cameraGroupList = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  getAllUsers(): void {
    this.userService
      .getAll()
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.userList = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  closeDialog(): void {
    this.dialog.close();
  }

  updateVehicle(): void {
    let data = this.form.getRawValue();

    this.enforcementVehicleService
      .updateVehicle(data)
      .pipe(first())
      .subscribe((response) => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(
            response.value,
            "Vehicle Updated Successfully!"
          );
          this.dialog.close(true);
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }
}
